const riot = require('riot');

riot.tag2('module-amazon-notice', '<p class="ts-pxs" data-is="atom-anchorify" text="{message}"></p>', 'module-amazon-notice,[data-is="module-amazon-notice"]{display:block}', '', function(opts) {


    var _contact = [this.opts.event.contact_email, this.opts.event.contact_site].filter(Boolean).join(' または ');

    var _message = `本キャンペーンは${this.opts.event.campaign_display_company_name}による提供です。
    本キャンペーンについてのお問い合わせはAmazonではお受けしておりません。
    ${this.opts.event.contact_name}（\u00a0${_contact}\u00a0）までお願いいたします。
    Amazon、Amazon.co.jpおよびそれらのロゴはAmazon.com, Inc.またはその関連会社の商標です。`;

    this.message = _message.replace(/^ +/gm, "");
});